@if (view.site && view.site.profile && view.site.profile.pages) {
    @switch (view.site.profile.pages.leisureTravel) {
        @case (1) {
            <app-leisure-travel-type01></app-leisure-travel-type01>
            }
        @case (2) {
            <app-leisure-travel-type02></app-leisure-travel-type02>
        }
        @case (3) {
            <app-xl-leisure-travel></app-xl-leisure-travel>
        }
    }
}
